<template>
    <div class="betSlip betSlip-empty" data-testid="betslip-empty">
        <div class="detailText detailText-emptyDeco">
            {{ i18n.t('no_bet_selected_msg') }}
        </div>
        <slot />
        <div class="detailText">
            {{ i18n.t('no_bet_selected_ins') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { i18n } from '@/core/lib/i18n';
</script>

<style lang="scss" scoped>
    @import "@/components/betSlip/BetSlip";
</style>
